/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for AccountingAccount controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, GetAccountingAccountByIdResponse, UpdateAccountingAccountRequest, AccountType, GetAccountingAccountsResponse, CreateAccountingAccountRequest, CreateAccountingAccountResponse } from "../models";

@Injectable({ providedIn: "root" })
export class AccountingAccountService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getAccountingAccountById(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<GetAccountingAccountByIdResponse>;
    getAccountingAccountById(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetAccountingAccountByIdResponse>>;
    getAccountingAccountById(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetAccountingAccountByIdResponse>>;
    getAccountingAccountById(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/AccountingAccount/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    updateAccountingAccount(id: number, updateAccountingAccountRequest: UpdateAccountingAccountRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    updateAccountingAccount(id: number, updateAccountingAccountRequest: UpdateAccountingAccountRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    updateAccountingAccount(id: number, updateAccountingAccountRequest: UpdateAccountingAccountRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    updateAccountingAccount(id: number, updateAccountingAccountRequest: UpdateAccountingAccountRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/AccountingAccount/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.put(url, updateAccountingAccountRequest, requestOptions);
    }

    deleteAccountingAccount(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    deleteAccountingAccount(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    deleteAccountingAccount(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    deleteAccountingAccount(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/AccountingAccount/${id}`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.delete(url, requestOptions);
    }

    getAccountingAccounts(searchTerm?: string | null, accountTypes?: (Array<AccountType> | null), observe?: 'body', options?: RequestOptions<'json'>): Observable<GetAccountingAccountsResponse>;
    getAccountingAccounts(searchTerm?: string | null, accountTypes?: (Array<AccountType> | null), observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<GetAccountingAccountsResponse>>;
    getAccountingAccounts(searchTerm?: string | null, accountTypes?: (Array<AccountType> | null), observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<GetAccountingAccountsResponse>>;
    getAccountingAccounts(searchTerm?: string | null, accountTypes?: (Array<AccountType> | null), observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/AccountingAccount`;

        let params = new HttpParams();
        if (searchTerm != null) {
            params = HttpParamsBuilder.addToHttpParams(params, searchTerm, 'searchTerm');
        }
        if (accountTypes != null) {
            params = HttpParamsBuilder.addToHttpParams(params, accountTypes, 'accountTypes');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.get(url, requestOptions);
    }

    createAccountingAccount(createAccountingAccountRequest: CreateAccountingAccountRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<CreateAccountingAccountResponse>;
    createAccountingAccount(createAccountingAccountRequest: CreateAccountingAccountRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<CreateAccountingAccountResponse>>;
    createAccountingAccount(createAccountingAccountRequest: CreateAccountingAccountRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<CreateAccountingAccountResponse>>;
    createAccountingAccount(createAccountingAccountRequest: CreateAccountingAccountRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/AccountingAccount`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        const requestOptions: any = {
            observe: observe as any,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        };

        return this.httpClient.post(url, createAccountingAccountRequest, requestOptions);
    }
}
